import { NameDto } from '../../Common/Types'

export interface NPaymentProviderOrderDto {
  configurationType: ConfigurationType
  methods: {
    configurationType: ConfigurationType
    country: NameDto<string> | null
    id: string
    method: NameDto<string>
    ordering: number
    deviceType: NameDto | null
    enabled?: boolean
  }[]
  country: NameDto<string>
  tickmillCompany: NameDto
}

export interface NPaymentProviderUpdateOrderDto {
  ordering: number
  methodCountryOrderId: string
  userReason: string
  countryId?: string
}

interface ConfigurationType {
  id: 0 | 1
  name: 'Deposit' | 1
}
export enum NPaymentProviderOrderKey {
  id = 'id',
  name = 'method.name',
  country = 'country.name',
  ordering = 'ordering',
  tickmillCompany = 'tickmillCompany.name',
}
